// Icon nội tuyến, vẽ bằng stroke.
// Kích thước mặc định 24 — khớp với text-base, để icon và chữ cùng
// trọng lượng thị giác. Truyền size khác khi cần nhấn mạnh (ví dụ
// đồng hồ đếm ngược).

export type IconName =
  | 'home'
  | 'practice'
  | 'exam'
  | 'chart'
  | 'arrow'
  | 'back'
  | 'check'
  | 'x'
  | 'clock'
  | 'lock'
  | 'chevronRight'

const P: Record<IconName, string> = {
  // Nhà: mái + thân.
  home: 'M3 10.5 12 3l9 7.5M5.5 9.5V20h13V9.5M9.5 20v-6h5v6',
  // Ôn luyện: bìa sách.
  practice: 'M4 4.5h6a2 2 0 0 1 2 2V20a2 2 0 0 0-2-2H4zM20 4.5h-6a2 2 0 0 0-2 2V20a2 2 0 0 1 2-2h6z',
  // Thi thử: giấy có dấu.
  exam: 'M6 3h8l4 4v14H6zM14 3v4h4M9 12h6M9 16h4',
  // Tiến độ: cột.
  chart: 'M4 20V10M10 20V4M16 20v-7M22 20H2',
  arrow: 'M5 12h13M12 5l7 7-7 7',
  /** Mũi tên trái — dùng cho nút "quay lại". */
  back: 'M10 5l7 7-7 7',
  check: 'M4.5 12.5 9.5 17.5 19.5 6.5',
  x: 'M6 6l12 12M18 6L6 18',
  clock: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 7v5.5l3.5 2',
  lock: 'M6 11h12v9H6zM8.5 11V7.5a3.5 3.5 0 0 1 7 0V11',
  // Mũi tên phải — dòng trong danh sách có thể bấm được (màn Câu đã sai).
  chevronRight: 'M9 5l7 7-7 7',
}

export function Icon({
  name,
  size = 24,
  className = '',
}: {
  name: IconName
  size?: number
  /** Đè màu. Không có nó thì chỉ đổi được kích thước — màu lấy từ
   *  `currentColor` của phần tử cha, mà dòng dữ liệu cần màu khác nhau (X đỏ,
   *  mũi tên xám). */
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`shrink-0 ${className}`.trim()}
      aria-hidden="true"
      focusable="false"
    >
      <path d={P[name]} />
    </svg>
  )
}
